import React from "react";
import "./page-layout.scss";

interface PageLayoutProps {
  children: React.ReactNode;
  centered?: boolean;
  fullHeight?: boolean;
  /** Drop the default border + padding — the host wallet already
   *  draws its own modal chrome and we don't want a second outline. */
  borderless?: boolean;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  centered = false,
  fullHeight = false,
  borderless = false,
}) => {
  return (
    <main
      className={`page-layout ${centered ? "page-layout--centered" : ""} ${fullHeight ? "page-layout--full-height" : ""} ${borderless ? "page-layout--borderless" : ""}`}
    >
      <div className="page-layout__container">{children}</div>
    </main>
  );
};

export default PageLayout;

